/* Inset tone bar, not border-left — an asymmetric border on a rounded box leaks
 * stray corner pixels; the inset shadow clips cleanly to the radius. The extra
 * 3px of left padding stands in for the removed border width. */
.ui-info-banner {
  display: flex;
  align-items: flex-start;
  gap: var(--lemn-space-3);
  padding: var(--lemn-space-4) var(--lemn-space-4) var(--lemn-space-4) calc(var(--lemn-space-4) + 3px);
  border-radius: var(--lemn-radius-medium);
  font-family: var(--lemn-font-body);
}

/* Floating mode: in flex-backed content regions, margin-top consumes short-page
 * slack; sticky keeps the banner pinned when the region scrolls. */
.ui-info-banner[data-floating="true"] {
  position: sticky;
  z-index: var(--lemn-z-chrome);
  flex-shrink: 0;
  bottom: calc(var(--lemn-space-3) + env(safe-area-inset-bottom, 0px));
  margin-top: auto;
  box-shadow: var(--lemn-shadow-overlay);
  animation: slide-bottom var(--lemn-duration-fast) var(--lemn-easing-standard);
}

.ui-info-banner__icon {
  flex: none;
  margin-top: 1px;
}

.ui-info-banner__body {
  display: grid;
  gap: var(--lemn-space-2);
  flex: 1 1 auto;
  min-width: 0;
  color: var(--lemn-color-text);
  font-size: var(--lemn-font-size-small);
  line-height: var(--lemn-line-height-small);
}

.ui-info-banner__title {
  font-weight: var(--lemn-font-weight-semibold);
  line-height: var(--lemn-line-height-body);
}

.ui-info-banner__content {
  min-width: 0;
}

.ui-info-banner__actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--lemn-space-2);
  align-items: center;
}

.ui-info-banner__dismiss {
  flex: none;
  margin: calc(var(--lemn-space-1) * -1);
}

.ui-info-banner[data-variant="info"] {
  background: var(--lemn-color-info-surface);
  box-shadow: inset 3px 0 0 var(--lemn-color-info);
}
.ui-info-banner[data-variant="info"] .ui-info-banner__icon {
  color: var(--lemn-color-info);
}

.ui-info-banner[data-variant="warn"] {
  background: var(--lemn-color-warning-surface);
  box-shadow: inset 3px 0 0 var(--lemn-color-warning);
}
.ui-info-banner[data-variant="warn"] .ui-info-banner__icon {
  color: var(--lemn-color-warning);
}

.ui-info-banner[data-variant="danger"] {
  background: var(--lemn-color-danger-surface);
  box-shadow: inset 3px 0 0 var(--lemn-color-danger);
}
.ui-info-banner[data-variant="danger"] .ui-info-banner__icon {
  color: var(--lemn-color-danger);
}

.ui-info-banner[data-variant="success"] {
  background: var(--lemn-color-success-surface);
  box-shadow: inset 3px 0 0 var(--lemn-color-success);
}
.ui-info-banner[data-variant="success"] .ui-info-banner__icon {
  color: var(--lemn-color-success);
}

.ui-info-banner[data-density="compact"] {
  box-sizing: border-box;
  width: fit-content;
  max-width: 100%;
  align-items: center;
  gap: var(--lemn-space-1);
  padding: var(--lemn-space-1) var(--lemn-space-2) var(--lemn-space-1) calc(var(--lemn-space-2) + 2px);
  border-radius: var(--lemn-radius-small);
}

.ui-info-banner[data-density="compact"] .ui-info-banner__icon {
  width: 12px;
  height: 12px;
  margin-top: 0;
}

.ui-info-banner[data-density="compact"] .ui-info-banner__body {
  gap: var(--lemn-space-1);
  overflow-wrap: anywhere;
  font-size: 11px;
  line-height: 14px;
}

.ui-info-banner[data-density="compact"] .ui-info-banner__dismiss {
  width: 24px;
  height: 24px;
}

.ui-info-banner[data-density="compact"][data-variant="info"] {
  box-shadow: inset 2px 0 0 var(--lemn-color-info);
}

.ui-info-banner[data-density="compact"][data-variant="warn"] {
  box-shadow: inset 2px 0 0 var(--lemn-color-warning);
}

.ui-info-banner[data-density="compact"][data-variant="danger"] {
  box-shadow: inset 2px 0 0 var(--lemn-color-danger);
}

.ui-info-banner[data-density="compact"][data-variant="success"] {
  box-shadow: inset 2px 0 0 var(--lemn-color-success);
}
